var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDatabase = function SvgDatabase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 163,
    height: 138,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#database_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF3E4",
    fillOpacity: 0.72,
    d: "M39.662 109.993C27.698 109.993 18 100.294 18 88.33s9.698-21.662 21.662-21.662c.444 0 .884.013 1.321.04v-.047C40.983 50.279 54.263 37 70.643 37c15.008 0 27.411 11.144 29.386 25.608.734-.069 1.477-.103 2.228-.103 13.113 0 23.743 10.63 23.743 23.744 0 13.114-10.63 23.744-23.743 23.744H39.662Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FED7AA",
    stroke: "#FED7AA",
    d: "M96 47.098c-9.307 0-17.713 1.247-23.774 3.25-3.034 1.002-5.452 2.185-7.102 3.475-1.656 1.293-2.468 2.635-2.468 3.959v57.549c0 1.324.812 2.666 2.468 3.96 1.65 1.289 4.069 2.472 7.102 3.474 6.061 2.003 14.467 3.251 23.774 3.251s17.713-1.248 23.774-3.251c3.034-1.002 5.452-2.185 7.102-3.474 1.656-1.294 2.468-2.636 2.468-3.96v-57.55c0-1.323-.812-2.665-2.468-3.958-1.65-1.29-4.068-2.473-7.102-3.475-6.061-2.003-14.467-3.25-23.774-3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB800",
    stroke: "#FFF7ED",
    d: "M96 47.098c-9.307 0-17.713 1.247-23.774 3.25-3.034 1.002-5.452 2.185-7.102 3.474-1.656 1.294-2.468 2.636-2.468 3.96 0 1.323.812 2.666 2.468 3.96 1.65 1.289 4.069 2.47 7.102 3.473 6.061 2.003 14.467 3.251 23.774 3.251s17.713-1.248 23.774-3.25c3.034-1.003 5.452-2.185 7.102-3.474 1.656-1.294 2.468-2.637 2.468-3.96 0-1.324-.812-2.666-2.468-3.96-1.65-1.289-4.068-2.472-7.102-3.474-6.061-2.003-14.467-3.25-23.774-3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB800",
    stroke: "#F7FBFD",
    d: "M62.656 96.149c0 1.323.812 2.665 2.468 3.959 1.65 1.289 4.068 2.472 7.102 3.474 6.061 2.003 14.467 3.25 23.774 3.25s17.713-1.247 23.774-3.25c3.034-1.002 5.452-2.185 7.102-3.474 1.656-1.294 2.468-2.636 2.468-3.96V79.836c-.474.662-1.1 1.29-1.852 1.877-1.775 1.387-4.313 2.614-7.404 3.636-6.188 2.044-14.704 3.3-24.088 3.3s-17.9-1.255-24.088-3.3c-3.091-1.022-5.629-2.249-7.404-3.636-.752-.587-1.378-1.215-1.852-1.877V96.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M123.097 76.566a2.786 2.786 0 1 1 0-5.572 2.786 2.786 0 0 1 0 5.572ZM123.097 95.894a2.786 2.786 0 1 1 0-5.572 2.786 2.786 0 0 1 0 5.572ZM123.097 115.223a2.786 2.786 0 1 1 0-5.573 2.786 2.786 0 0 1 0 5.573Z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#database_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E89B06",
    d: "M45 114.5c0-6.351 5.149-11.5 11.5-11.5S68 108.149 68 114.5 62.851 126 56.5 126 45 120.851 45 114.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8FAFC",
    d: "M52.206 115.048a4.29 4.29 0 0 1-.04-.548c0-.186.017-.368.04-.548l-1.223-.931a.276.276 0 0 1-.07-.36l1.157-1.949a.29.29 0 0 1 .353-.121l1.44.565c.297-.222.624-.411.976-.554l.217-1.491a.295.295 0 0 1 .29-.236h2.312a.29.29 0 0 1 .286.236l.217 1.491c.352.143.679.329.977.554l1.44-.565c.13-.048.28 0 .352.121l1.156 1.949a.277.277 0 0 1-.07.36l-1.219.931c.023.18.04.362.04.548 0 .186-.017.368-.04.548l1.22.931c.11.085.141.237.07.36l-1.157 1.949a.29.29 0 0 1-.353.121l-1.44-.565a4.407 4.407 0 0 1-.976.554l-.217 1.491a.29.29 0 0 1-.286.236h-2.313a.29.29 0 0 1-.286-.236l-.217-1.491a4.289 4.289 0 0 1-.977-.554l-1.44.565c-.13.048-.28 0-.352-.121l-1.156-1.949a.277.277 0 0 1 .07-.36l1.219-.931Zm4.295 1.421c1.12 0 2.024-.881 2.024-1.969s-.905-1.969-2.024-1.969c-1.118 0-2.023.881-2.023 1.969s.905 1.969 2.023 1.969Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "database_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h163v138H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "database_svg__b",
    width: 85.836,
    height: 162.836,
    x: -1.008,
    y: 89.082,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.91,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.959
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11215_16169"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_11215_16169",
    result: "shape"
  })))));
};
export default SvgDatabase;